// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "ce3ed181da88e71900d4d70fc2a96536af7c31e7/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};